<div (clickOutside)="onClickedOutside($event)" class="position-fixed d-flex h-100" style="z-index: 1000;background-image: url(./assets/images/background/side-bg.jpg);background-repeat: no-repeat;background-position: top left; background-size: cover;">
  <div class="h-100 shadow" id="v-pills-tab">
    <ul class="sidebar nav nav-tabs nav-flush d-flex flex-column justify-content-center align-items-center mb-auto text-center vh-100" role="tablist" aria-orientation="vertical" style="padding-bottom: 10rem">
      <li class="nav-item mt-0 mb-auto">
        <a class="nav-link py-5" (click)="SideContentView('')" [routerLink]="['/utama']" routerLinkActive="active">
          <!-- <span class="nav-icons-bg"> -->
          <img class="nav-home" src="./assets/icons/home.svg" height="40" width="40" />
          <!-- </span> -->
        </a>
      </li>
      <li class="nav-item side-item" (click)="SideContentView('UserProfile')"
          [class.active]="UserProfileStatus === true">
        <a class="nav-link p-1">
          <img class="nav-icons" src="./assets/icons/user-circle.svg" height="40" width="40" />
          <p class="nav-label text-white">Profil</p>
        </a>
      </li>
      <li class="nav-item side-item" (click)="SideContentView('PembayarCukai')"
          [class.active]="PembayarCukaiStatus === true">
        <a class="nav-link p-1">
          <img class="nav-icons" src="./assets/icons/pembayar-cukai.svg" height="40" width="40" />
          <p class="nav-label text-white">Pembayar Cukai</p>
        </a>
      </li>
      <li class="nav-item side-item" (click)="SideContentView('Integrasi')" [class.active]="IntegrasiStatus === true">
        <a class="nav-link p-1">
          <img class="nav-icons" src="./assets/icons/integrasi.svg" height="40" width="40" />
          <p class="nav-label text-white">Integrasi</p>
        </a>
      </li>
      <li class="nav-item side-item" (click)="SideContentView('Penyenggaraan')"
          [class.active]="PenyenggaraanStatus === true">
        <a class="nav-link p-1">
          <img class="nav-icons" src="./assets/icons/penyenggaraan.svg" height="40" width="40" />
          <p class="nav-label text-white">Penyenggaraan</p>
        </a>
      </li>
      <li class="nav-item mb-auto" (click)="SideContentView('BantuanSistem')"
          [class.active]="BantuanSistemStatus === true">
        <a class="nav-link p-1">
          <img class="nav-icons" src="./assets/icons/bantuan.svg" height="40" width="40" />
          <p class="nav-label text-white">Bantuan</p>
        </a>
      </li>
    </ul>
  </div>
  <!-- Profile Sidemenu  -->
  <div class="container-fluid submenu card card-body p-0 h-100 border-0 shadow bg-transparent"
    *ngIf="UserProfileStatus">
    <div class="submenu-content p-0 m-0">
      <app-sidebar-profile (StaffRolesEvent)="ChangeRolesFromChild($event)"></app-sidebar-profile>
    </div>
  </div>
  <!-- Pembayar Cukai Sidemenu  -->
  <div class="container-fluid submenu card card-body p-0 h-100 border-0 shadow" *ngIf="PembayarCukaiStatus">
    <div class="submenu-content p-0 m-0">
      <app-sidebar-profile (StaffRolesEvent)="ChangeRolesFromChild($event)"></app-sidebar-profile>
      <ul class="list-group list-group-flush">
        <li class="list-group-item my-4">
          <a class="text-decoration-none text-black btn-toggle parent" data-bs-toggle="collapse"
            href="#PembayarCukaiCollapse" role="button" aria-expanded="true"
            aria-controls="PembayarCukaiCollapse">Pembayar Cukai</a>
          <div class="dropdown-divider"></div>
          <div class="collapse show" id="PembayarCukaiCollapse">
            <ul class="list-group list-group-flush">
              <li class="list-group-item second-level">
                <a routerLink="/penerimaan-pelantikan-permohonan-online" class="text-decoration-none text-black child" (click)="URLClicked()">Penerimaan Pelantikan Ejen Cukai</a>
              </li>
              <li class="list-group-item second-level inner-arrow">
                <a routerLink="/e-borang" class="text-decoration-none text-black child" (click)="URLClicked()">e-Borang</a>
              </li>
              <li class="list-group-item second-level inner-arrow">
                <a routerLink="/status-e-borang" class="text-decoration-none text-black child" (click)="URLClicked()">Status e-Borang</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
  <!-- Integrasi Sidemenu  -->
  <div class="container-fluid submenu card card-body p-0 h-100 border-0 shadow" *ngIf="IntegrasiStatus">
    <div class="submenu-content p-0 m-0">
      <app-sidebar-profile (StaffRolesEvent)="ChangeRolesFromChild($event)"></app-sidebar-profile>
      <ul class="list-group list-group-flush">
        <li class="list-group-item my-4">
          <a class="text-decoration-none text-black arrow parent" data-bs-toggle="collapse" href="#IntegrasiCollapse"
            role="button" aria-expanded="true" aria-controls="IntegrasiCollapse">Integrasi</a>
          <div class="dropdown-divider"></div>
          <div class="collapse show" id="IntegrasiCollapse">
            <ul class="list-group list-group-flush">
              <li class="list-group-item second-level">
                <a class="text-decoration-none text-black child" data-bs-toggle="collapse" href="#DTSCollapse"
                   role="button" aria-expanded="false" aria-controls="DTSCollapse">e-Dts</a>
                <div class="collapse" id="DTSCollapse">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item second-level">
                      <a routerLink="/profil-firma" class="text-decoration-none text-black child" (click)="URLClicked()">Profil Firma</a>
                    </li>
                    <li class="list-group-item second-level">
                      <a routerLink="/cetak-draf" class="text-decoration-none text-black child" (click)="URLClicked()">Cetak Draf</a>
                    </li>
                    <li class="list-group-item second-level">
                      <a routerLink="/penghantaran-e-borang" class="text-decoration-none text-black child" (click)="URLClicked()">Penghantaran e-Borang</a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="list-group-item second-level inner-arrow">
                <!--<a class="text-decoration-none text-black child" data-bs-toggle="modal" data-bs-target="#penampanModal">MITRS</a>-->
                <a routerLink="/mitrs" class="text-decoration-none text-black child" (click)="URLClicked()">MITRS</a>
              </li>
              <li class="list-group-item second-level inner-arrow" *ngIf="showEWHT">
                <a routerLink="/e-wht" class="text-decoration-none text-black child" *ngIf="showEWHT" (click)="URLClicked()">e-WHT/ANSURAN/107D</a>
              </li>
              <li class="list-group-item second-level inner-arrow">
                <a routerLink="/e-ckht" class="text-decoration-none text-black child" (click)="URLClicked()">e-CKHT</a>
              </li>
              <li class="list-group-item second-level inner-arrow">
                <a routerLink="/e-ckm-cp22" class="text-decoration-none text-black child" (click)="URLClicked()">{{ integrasiCkmTitle }}</a>
              </li>
              <li class="list-group-item second-level inner-arrow">
                <a routerLink="/e-spc" class="text-decoration-none text-black child" (click)="URLClicked()">e-SPC</a>
              </li>
              <li class="list-group-item second-level inner-arrow" *ngIf="showEOT">
                <a routerLink="/e-eot" class="text-decoration-none text-black child" (click)="URLClicked()">e-Lanjutan Masa</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- Penyenggaraan Sidemenu  -->
  <div class="container-fluid submenu card card-body p-0 h-100 border-0 shadow" *ngIf="PenyenggaraanStatus">
    <div class="submenu-content p-0 m-0">
      <app-sidebar-profile (StaffRolesEvent)="ChangeRolesFromChild($event)"></app-sidebar-profile>
      <ul class="list-group list-group-flush">
        <li class="list-group-item my-4">
          <a class="text-decoration-none text-black arrow parent" data-bs-toggle="collapse"
            href="#PenyenggaraanCollapse" role="button" aria-expanded="true"
            aria-controls="PenyenggaraanCollapse">Penyenggaraan</a>
          <div class="dropdown-divider"></div>
          <div class="collapse show" id="PenyenggaraanCollapse">
            <ul class="list-group list-group-flush">
              <li class="list-group-item second-level">
                <a routerLink="/daftar-kemaskini" class="text-decoration-none text-black child" (click)="URLClicked()">Daftar / Kemaskini Pengguna</a>
              </li>
              <li class="list-group-item second-level inner-arrow">
                <a routerLink="/carian-hubungan" class="text-decoration-none text-black child" (click)="URLClicked()">Carian Hubungan</a>
              </li>
              <li class="list-group-item second-level inner-arrow">
                <a routerLink="/agihan-hubungan" class="text-decoration-none text-black child" (click)="URLClicked()">Agihan Hubungan</a>
              </li>
              <li class="list-group-item second-level inner-arrow">
                <a routerLink="/log-audit" class="text-decoration-none text-black child" (click)="URLClicked()">Log Audit</a>
              </li>
              <li class="list-group-item second-level inner-arrow">
                <a routerLink="/agih-e-borang-ejen-cukai" class="text-decoration-none text-black child" (click)="URLClicked()">Agih e-Borang (Ejen Cukai)</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <!-- Bantuan Sistem Sidemenu  -->
  <div class="container-fluid submenu card card-body p-0 h-100 border-0 shadow" *ngIf="BantuanSistemStatus">
    <div class="submenu-content p-0 m-0">
      <app-sidebar-profile (StaffRolesEvent)="ChangeRolesFromChild($event)"></app-sidebar-profile>
      <ul class="list-group list-group-flush">
        <li class="list-group-item my-4">
          <a class="text-decoration-none text-black btn-toggle parent" data-bs-toggle="collapse"
             href="#BantuanSistemCollapse" role="button" aria-expanded="true"
             aria-controls="BantuanSistemCollapse">Bantuan Sistem</a>
          <div class="dropdown-divider"></div>
          <div class="collapse show" id="BantuanSistemCollapse">
            <ul class="list-group list-group-flush">
              <li class="list-group-item second-level inner-arrow">
                <a routerLink="/bantuan-edts" class="text-decoration-none text-black child" (click)="URLClicked()">Bantuan eDTS</a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<!--PENAMPAN Modal-->
<div class="modal fade" id="penampanModal" tabindex="-1" aria-labelledby="penampanModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content" style="background-color: rgba(223, 224, 224, 0.9);border-radius: 1.7rem !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-center align-items-center">
          <img src="../../../../assets/icons/restricted.svg" height="90" width="90" alt="..." />
        </div>
        <h3 class="fw-bold text-center">PEMAKLUMAN NOTIS PEMBERITAHUAN</h3>
        <p class="text-center">
          Pembayar cukai yang dihormati
        </p>
        <!--<p class="text-center">
          Dimaklumkan capaian ke menu MITRS sedang mengalami gangguan pada<span class="fw-bold"> Jumaat 19 September 2025 pukul 10.00 malam sehingga 11.00 malam.</span>
        </p>-->
        <p class="text-center">
          Dimaklumkan bahawa perkhidmatan e-MITRS di TAeF sedang mengalami gangguan. Tindakan pembaikan sedang dilaksanakan.
        </p>
        <p class="text-center">
          Mohon maaf atas kesulitan
        </p>
      </div>
    </div>
  </div>
</div>
